import {api} from "@/store/resources";

export default {
    namespaced: true,
    state: {
        tokenList: {
            data: [],
            dirty: true
        }
    },
    getters: {},
    actions: {
        createNewAPIToken({}, payload) {
            return api.space_api_token.save(payload);
        },
        deleteAPIToken({}, id) {
            return api.sessions.delete({id});
        },
        async fetchTokenList({commit}) {
            commit('setTokenListDirty')
            try {
                const res = await api.sessions.get({is_api: 1});
                if (res.body.success) {
                    commit('setTokenList', res.body.data.rows);
                }
            } catch (err) {
                console.error(err)
            }
        }
    },
    mutations: {
        setTokenListDirty(state) {
            state.tokenList.dirty = true;
        },
        setTokenList(state, payload) {
            state.tokenList.data = payload;
            state.tokenList.dirty = false;
        }
    },
}